export type ErrorResponse = {
  message: string;
  errorCode: ErrorCode;
};

// TODO: add separate error code enums per entity and create a union type for ErrorCode
export enum ErrorCode {
  DUPLICATE_GLN = 'ORG-107',
  DUPLICATE_SUBORGANIZATION_NAME = 'ORG-117',
  VERSION_MISMATCH_ORGANIZATION_SERIVCE = 'ORG-005',
  REQUESTER_WITH_ID_IS_NOT_AGENT = 'ORG-022',
  ORG_MEMBERSHIP_CANNOT_DELETE_LAST_ACTIVE_MEMBER = 'USE-047',
  ORG_MEMBERSHIP_CANNOT_DELETE_LAST_MEMBER = 'USE-048',
  ORG_MEMBERSHIP_CANNOT_DELETE_LAST_ADMIN = 'USE-049',
  USER_APPOINTED_TO_FURTHER_QUALIFICATION = 'USE-003',
  USER_ALREADY_IN_ORGANIZATION = 'USE-008',
  USER_INACTIVE_ORG = 'USE-064',
  USER_UNKNOWN_ERRROR = 'USE-999',
}

export enum AuthorizerErrorCode {
  AUTHORIZER_ADD_USERS_TO_GROUPS_LIMIT_REACHED = 'AUT-040',
}

export type ErrorDetail = {
  message: string;
  errorCode: ErrorCode;
  value?: string;
};

export enum ErrorMessage {
  VERSION_MISMATCH = 'Version does not match',
  CANNOT_REVOKE_OWN_ROLE = 'ORGANIZATION_ADMIN is not allowed to revoke own role',
  DELETE_LAST_ORGANIZATION_ADMIN = 'There has to be at least one User with the role ORGANIZATION_ADMIN',
}
